/* this file is transformed by vux-loader */
/* eslint-disable */
import _createForOfIteratorHelper from "G:/SVN/\u5B9A\u5236\u9879\u76EE/\u534E\u7535\u5F00\u5173/7_\u6E90\u4EE3\u7801/front/smy-vux-cli3-h5-huadian/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import DingTalk from 'DingTalk';
import request from '@/api/request';
import store from '../store';

var $qs = require('querystring').stringify;

function getConfig(url) {
  return new Promise(function (resolve, reject) {
    var data = {
      url: encodeURI(window.location.href.substring(0, window.location.href.indexOf('#'))),
      corpid: dingLogin().corpid
    };
    request.post(url, $qs(data)).then(function (res) {
      // 钉钉配置
      DingTalk.config({
        agentId: res.data.agentid,
        corpId: res.data.corpId,
        timeStamp: res.data.timeStamp,
        nonceStr: res.data.nonceStr,
        signature: res.data.signature,
        jsApiList: ['runtime.permission.requestAuthCode', 'runtime.permission.requestOperateAuthCode', 'device.geolocation.get', 'biz.util.scan', 'biz.ding.post', 'biz.ding.create', 'biz.util.uploadImage', 'biz.util.uploadImageFromCamera', 'biz.navigation.setTitle', 'device.base.getUUID', // 获取uuid
        'dd.version', // 获取钉钉容器版本号
        'biz.telephone.call', // 拨打钉钉电话(电话会议)
        'biz.telephone.showCallMenu', // 通用电话拨打
        'biz.util.share', // 分享
        'biz.map.locate', // 地图
        'biz.map.view', // 导航
        'biz.navigation.setMenu', // 导航栏右侧多个按钮
        'biz.navigation.setRight', // 导航栏右侧单个按钮（隐藏用）
        'biz.chat.pickConversation', // 获取会话信息(发起群聊)
        'biz.util.open', 'biz.util.openLink', 'biz.cspace.saveFile', 'device.geolocation.start', 'device.geolocation.stop', 'device.base.enableBluetooth', 'device.base.scanBleDevice', 'device.base.stopScanBleDevice']
      });
      console.log('钉钉 ready'); // 钉钉初始化

      DingTalk.ready(function () {
        console.log('钉钉 ready into'); // 钉钉免登

        resolve(res);
      }); // 异常抛出

      DingTalk.error(function (err) {
        reject(err);
      });
    });
  });
}

function dingLogin() {
  // 获取参数
  var paramsStr = location.search;
  var params = {};

  if (paramsStr.indexOf('?') !== -1) {
    paramsStr = paramsStr.substr(1);
    var paramsStrArray = paramsStr.split('&');

    var _iterator = _createForOfIteratorHelper(paramsStrArray),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        params[item.split('=')[0]] = item.split('=')[1];
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return params;
} // 无法作为插件 需放在beforeEach里面


var install = function install(Vue, options) {
  // 开发环境免登
  return new Promise(function (resolve, reject) {
    getConfig('/jsapi/cfg').then(function (res) {
      store.commit('globalStore/_config', res.data); // 发布之后 进入前端页面时已经登录生成sessionUser 不需要此段

      if (process.env.NODE_ENV !== 'production') {
        DingTalk.runtime.permission.requestAuthCode({
          corpId: res.data.corpId,
          onSuccess: function onSuccess(result) {
            // store.commit('globalStore/_config', result)
            request.post('/jsapi/userinfo', $qs({
              code: result.code,
              corpId: res.data.corpId
            })).then(function (res) {
              resolve(DingTalk);
            });
          },
          onFail: function onFail(err) {
            console.log(JSON.stringify(err));
            reject(err);
          }
        });
      } else {
        resolve(DingTalk);
      }

      Vue.prototype.$DingTalk = DingTalk;
    }).catch(function (err) {
      alert('error:' + JSON.stringify(err));
      Vue.prototype.$DingTalk = DingTalk;
      reject(err);
    });
  });
};

export default {
  install: install
};